var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"destroy-on-close":true,"title":"选择检查项","visible":_vm.visible,"width":1200},on:{"cancel":function($event){_vm.visible = false},"ok":_vm.handleOk}},[_c('patrol-item-simple-table',{attrs:{"getFunc":_vm.getFunc,"sourceType":_vm.sourceType},on:{"tableSelectedData":_vm.getSelectedData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }